var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisibility = function SvgVisibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visibility_svg2__a",
    x1: 20.69,
    x2: 164.69,
    y1: 143.39,
    y2: 36.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#visibility_svg2__a",
    id: "visibility_svg2__b",
    x1: -3.4,
    x2: 140.6,
    y1: 110.98,
    y2: 3.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#visibility_svg2__a",
    id: "visibility_svg2__c",
    x1: -15.75,
    x2: 128.25,
    y1: 94.36,
    y2: -12.64
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#visibility_svg2__a",
    id: "visibility_svg2__d",
    x1: 35.19,
    x2: 179.19,
    y1: 162.91,
    y2: 55.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#visibility_svg2__a",
    id: "visibility_svg2__e",
    x1: 39.93,
    x2: 183.93,
    y1: 169.28,
    y2: 62.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#visibility_svg2__a",
    id: "visibility_svg2__f",
    x1: 40.3,
    x2: 184.3,
    y1: 169.79,
    y2: 62.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#visibility_svg2__a",
    id: "visibility_svg2__g",
    x1: 39.92,
    x2: 183.92,
    y1: 169.28,
    y2: 62.28
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M74.51 109.82a6.44 6.44 0 0 1-4.72-2.06 6.4 6.4 0 0 1-1.71-4.36c0-3.55 2.88-6.43 6.43-6.43 1.23 0 2.42.35 3.45 1.01a6.39 6.39 0 0 1 2.98 5.42c0 3.54-2.88 6.42-6.43 6.42m0-8.49c-1.14 0-2.08.93-2.08 2.08 0 .52.2 1.02.55 1.41 1.18 1.27 3.6.32 3.6-1.41 0-.71-.36-1.37-.97-1.75h-.01c-.32-.22-.7-.33-1.1-.33",
    style: {
      fill: "url(#visibility_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 54.69c-3.61 0-6.53-2.92-6.53-6.53V20.12c0-3.6 2.92-6.53 6.53-6.53s6.53 2.92 6.53 6.53v28.04c0 3.6-2.92 6.53-6.53 6.53",
    style: {
      fill: "url(#visibility_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.42 77.09c-1.67 0-3.34-.64-4.62-1.91L14.77 57.15c-2.55-2.55-2.55-6.68 0-9.23s6.68-2.55 9.23 0l18.03 18.03a6.524 6.524 0 0 1-4.62 11.14",
    style: {
      fill: "url(#visibility_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.58 77.09a6.524 6.524 0 0 1-4.62-11.14l18.03-18.03c2.55-2.55 6.68-2.55 9.23 0s2.55 6.68 0 9.23l-18.03 18.03a6.53 6.53 0 0 1-4.62 1.91",
    style: {
      fill: "url(#visibility_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 186.4c-59.11 0-97.3-55.74-98.89-58.12a6.52 6.52 0 0 1 0-7.28C2.7 118.62 40.88 62.88 100 62.88s97.29 55.74 98.89 58.12a6.52 6.52 0 0 1 0 7.28c-1.6 2.38-39.77 58.12-98.89 58.12m-85.36-61.76c9.25 11.89 41.46 48.71 85.36 48.71s76.1-36.82 85.35-48.71c-9.25-11.89-41.46-48.71-85.35-48.71s-76.11 36.83-85.36 48.71",
    style: {
      fill: "url(#visibility_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 165.16c-22.34 0-40.52-18.18-40.52-40.52l.09-2.62s.03-.47.03-.51l.39-3.27c0-.09.07-.44.13-.81l12.87 2.2c-.01.1-.13.8-.15.89l-.18 1.5-.04.48-.08 2.14c0 15.14 12.32 27.47 27.46 27.47 1.87 0 3.73-.19 5.53-.56.9-.18 1.78-.41 2.64-.67.85-.27 1.7-.57 2.52-.92a27.53 27.53 0 0 0 7.43-4.67c.47-.41.9-.82 1.31-1.24.46-.46.91-.94 1.34-1.44.59-.67 1.11-1.34 1.61-2.04.3-.44.54-.77.76-1.12l.34-.54a27.495 27.495 0 0 0 3.99-14.27c0-15.14-12.32-27.46-27.46-27.46l-1.25.03c-.08 0-.6.03-.67.03-.04 0-.4.03-.44.03-.03 0-.58.06-.61.06-.16.03-.97.13-1.14.14-.12.02-.37.07-.49.08 0 0-.5.09-.52.1-.05 0-.48.1-.54.11l-2.96.79s-.84.3-.86.3c-3.36 1.3-7.3-.3-8.6-3.66-1.31-3.36.2-7.08 3.56-8.39l7.8-2.12c.08-.01.48-.08.56-.09l.49-.07h.06l2.33-.26c.06 0 .41-.03.47-.03-.15-.04.16-.01.43-.02l2.38-.07c22.34 0 40.52 18.18 40.52 40.51a40.6 40.6 0 0 1-5.87 21.01l-.52.84c-.31.49-.65.98-.99 1.47-.86 1.21-1.66 2.22-2.51 3.2-.61.7-1.27 1.42-1.97 2.11-.63.63-1.28 1.24-1.95 1.82a40.1 40.1 0 0 1-9.25 6.11c-.54.26-1.1.51-1.68.76-1.22.51-2.46.97-3.73 1.36-1.28.4-2.58.74-3.9 1.01-2.65.55-5.4.82-8.15.82",
    style: {
      fill: "url(#visibility_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 143.91c-10.62 0-19.27-8.64-19.27-19.27s8.65-19.27 19.27-19.27 19.27 8.64 19.27 19.27-8.65 19.27-19.27 19.27m0-25.49c-3.43 0-6.22 2.79-6.22 6.22s2.79 6.22 6.22 6.22 6.22-2.79 6.22-6.22-2.79-6.22-6.22-6.22",
    style: {
      fill: "url(#visibility_svg2__g)"
    }
  }));
};
export default SvgVisibility;